import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, fmtErr } from "../../lib/api";
import { Anchor, ArrowRight, KeyRound } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) {
      setErr(fmtErr(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-zinc-50">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-zinc-200 rounded-lg p-8 space-y-6" data-testid="forgot-form">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-md bg-ink text-white grid place-items-center">
            <Anchor className="h-4 w-4" />
          </div>
          <span className="font-display text-[17px] font-medium">Seavanto</span>
        </Link>

        <div>
          <KeyRound className="h-6 w-6 text-ink mb-3" />
          <h1 className="font-display text-2xl font-medium tracking-tight">{t("auth.forgot_password_title")}</h1>
          <p className="text-sm text-zinc-600 mt-1">
            {t("auth.forgot_password_subtitle")}
          </p>
        </div>

        {sent ? (
          <div className="rounded-md border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800" data-testid="forgot-sent">
            {t("auth.forgot_sent", { email })}
          </div>
        ) : (
          <>
            <div>
              <Label htmlFor="email">{t("auth.email")}</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
            </div>
            {err && <div className="text-sm text-red-600">{err}</div>}
            <Button type="submit" disabled={busy} className="w-full bg-ink hover:bg-black" data-testid="forgot-submit">
              {busy ? t("auth.sending") : t("auth.send_reset_link")} <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </>
        )}

        <div className="text-sm text-center">
          <Link to="/login" className="text-zinc-600 hover:text-ink" data-testid="back-to-login">{t("auth.back_to_signin")}</Link>
        </div>
      </form>
    </div>
  );
}
